
<template>
  <div>
    <page-title icon="fa fa-cog" main="Configuração" sub="Período de Vigência">
      <template v-slot:actions>
        <base-button
          @click="register"
          type="info"
          class="ml-3"
          size="sm"
          >Novo período de vigência</base-button
        >
      </template>
    </page-title>
    <div class="card mt-2" style="padding: 0rem 1rem">
      <label class="form-control-label mt-4">Ano PPR</label>
      <multiselect
        v-model="filter.anosafra"
        :options="optionsPprs"
        label="descricao"
        track-by="id"
        :allow-empty="false"
        select-label=""
        deselect-label=""
        placeholder="Selecionar Ano Safra"
        @input="search"
        class="mb-4"
        >
      </multiselect>
      <!-- Transform modal component -->
      <modal :show.sync="modals.modal0" id="anosafra">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Novo Periodo de Vigência</h5>
        </template>
        <form role="form" @submit.prevent="save">
          <div class="row justify-content-md-center">
            <div class="col-12">
              <base-input
                type="text"
                label="Descrição do Período de Vigência"
                placeholder="Nome do Período de Vigência"
                v-model="suggestion.descricao"
                :required="true"
                aria-label="Nome do Período de Vigência"
              ></base-input>
            </div>
            <div class="col-12">
              <label class="form-control-label">Ano Safra</label><br>
              <multiselect
                v-model="anosafra"
                :options="anosafras"
                placeholder="Selecione um anosafra "
                label="descricao"
                track-by="id"
                :preserveSearch="true"
                :showNoResults="false"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
            <div class="col-12 mt-3">
              <label class="form-control-label" style="pa">Duração do Periodo de Vigência</label><br>
              <el-date-picker
                v-model="suggestionDateRange"
                type="daterange"
                :picker-options="{ disabledDate: disabledDate }"
                :required="true"
                range-separator="-"
                start-placeholder="Data início"
                end-placeholder="Data fim"
                unlink-panels
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
            </div>
            <div class="col-12  mt-3">
              <label class="form-control-label">Data Limite para Alteração</label><br>
              <el-date-picker
                v-model="suggestion.update_end_date"
                :required="true"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button type="secondary" @click="modals.modal0 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="save" v-loading="savingPeriod">Salvar</base-button>
        </template>
      </modal>

      <modal :show.sync="modals.modal1" id="anosafra-edit">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Editar Perioodo de Vigência</h5>
        </template>
        <form role="form" @submit.prevent="editAnoPpr">
          <div class="row justify-content-md-center">
            <div class="col-12 form-group">
              <label class="form-control-label">Descrição do Periodo de Vigência</label><br>
              <input
                type="text"
                class="form-control"
                placeholder="Nome do Ano Safra"
                v-model="anoPpr.descricao"
                aria-label="Nome do Ano Safra"
              />
            </div>
            <div class="col-12">
              <label class="form-control-label">Ano Safra</label><br>
              <multiselect
                v-model="anosafra"
                :options="anosafras"
                placeholder="Selecione um anosafra "
                label="descricao"
                track-by="id"
                :preserveSearch="true"
                :showNoResults="false"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Duração do Período de Vigência</label><br>
              <el-date-picker
                v-model="anoPprDateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="Data início"
                end-placeholder="Data fim"
                unlink-panels
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Data Limite para Alteração</label><br>
              <el-date-picker
                v-model="anoPpr.update_end_date"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button type="secondary" @click="modals.modal1 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="editAnoPpr">Salvar</base-button>
        </template>
      </modal>

      <div class="border-0 ">
        <h3 class="mb-2 ml-2">Periodo de Vigência cadastrados:</h3>
      </div>

      <el-table
        v-loading = "isLoading"
        :data="anoPprs"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        style="width: 100%;"
      >
        <el-table-column label="Status" prop="is_open" width="100px" v-slot="{ row }" sortable>
          <badge class="badge-dot mr-4" type v-if="row.is_open">
            <i class="bg-success"></i> Aberto
          </badge>
          <badge class="badge-dot mr-4" type v-else>
            <i class="bg-danger"></i> Fechado
          </badge>
        </el-table-column>
        <el-table-column
          label="Descrição"
          prop="descricao"
          sortable
        />
        <el-table-column
          label="Ano Safra"
          prop="anosafra.descricao"
          sortable
        />

        <el-table-column label="Data de inicio" width="180px" prop="start_date" v-slot="{ row }" sortable >
          {{row.start_date | formatDate}}
        </el-table-column>
        <el-table-column width="180px" label="Data de fim" prop="end_date" v-slot="{ row }" sortable >
          {{row.end_date | formatDate}}
        </el-table-column>
        <el-table-column width="180px" label="Limite de Alteração" prop="update_end_date" v-slot="{ row }" sortable>
          {{row.update_end_date | formatDate}}
        </el-table-column>

        <el-table-column
          label="Ações"
          width="80px"
          prop="acoes"
          v-slot="{ row }"
        >
          <el-dropdown
            trigger="hover"
            class="dropdown"
            style="cursor: pointer;"
          >
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
              <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>

      <div class="card-footer py-4 d-flex justify-content-end" >
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        >
        </base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import moment from "moment";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
} from "element-ui";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";



extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

const today = new Date();
const dataAtual = moment(today);

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    PageTitle,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    Multiselect,
  },
  data() {
    return {
      filter: {},
      filtered: false,
      modals: {
        modal0: false,
        modal1: false,
      },
      paginated_data: [],
      anoPpr: {},
      item: "",
      anoPprs: [],
      isLoading: false,
      errors: [],
      suggestion: {},
      savingPeriod: false,
      anosafras: [],
      config: {
        altInput: false,
        allowInput: true,
        dateFormat: "d/m/Y",
        locale: Portuguese,
      },
      optionsPprs: [],
    };
  },

  mounted() {
    this.getAnosafras()
    this.$nextTick(this.setData());
    this.loadAnoPPR();
  },
  watch: {
    anosafra(newAnosafra) {
      this.suggestion.anosafra_id = newAnosafra.id
    },
  },
  methods: {
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    formatterGender(row, column) {
      return row.gender == 0 ? "M" : "F";
    },

    formatterStatus(row, column) {
      return row.status == true ? "Ativo" : "Inativo";
    },
    async getAnosafras() {
      this.isLoading = true;

      try {
        const response = await this.$http.secured.get("/api/v1/anosafras", { params: { unpaged: true, name_only: true } })
        this.anosafras = response.data;
      } catch (error) {
        console.error("[PprConfig][getAnosafras] error while getting anosafras: ", error)
      }

      this.isLoading = false;
    },
    setData(q, page) {
      console.log(q)
      console.log(page)
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;

      this.$http.secured
        .get("/api/v1/admin/participation_pprs", {
          params: {
            page: page,
            q: q,
          },
        })
        .then((response) => {
          console.log(response)
          this.anoPprs = response.data.participation_pprs || [];
          console.log(this.anoPprs)
          for (let anoPpr = 0; anoPpr < this.anoPprs.length; anoPpr++) {
            if(this.anoPprs[anoPpr].start_date) this.anoPprs[anoPpr].start_date = new Date(`${this.anoPprs[anoPpr].start_date}T00:00`)
            if(this.anoPprs[anoPpr].end_date) this.anoPprs[anoPpr].end_date = new Date(`${this.anoPprs[anoPpr].end_date}T00:00`)
            if(this.anoPprs[anoPpr].update_end_date) this.anoPprs[anoPpr].update_end_date = new Date(`${this.anoPprs[anoPpr].update_end_date}T00:00`)
          }
          this.getSuggestion();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    search() {
      this.filtered = !this.emptyFilter;
       let q = {}
      q.descricao = this.filter.descricao.descricao
      this.setData(q);
      this.filter = {};
    },

    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.setData(filterInput, page);
    },
    edit(anoPpr) {
      this.anoPpr = anoPpr;
      this.modals.modal1 = true;
    },
    editAnoPpr() {
      this.savingPeriod = true;
      this.$http.secured
        .put(`/api/v1/admin/participation_pprs/${this.anoPpr.id}`, this.anoPpr)
        .then((response) => {
          this.savingPeriod = false;
          this.response = response.data;
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.anoPpr = {};
          this.modals.modal1 = false;
        })
        .catch((error) => this.setError(error, "Cannot update anoPpr"));
    },
    loadAnoPPR() {
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`)
        .then((response) => {
          console.log(response)
          this.anoPprs = response.data;
          this.optionsPprs = response.data.participation_pprs;
          console.log('Ano ppr', this.optionsPprs)
          this.count = response.data.count;
          this.limit = response.data.limit;

          for (let anoPpr = 0; anoPpr < this.anoPprs.length; anoPpr++) {
            if(this.anoPprs[anoPpr].start_date) this.anoPprs[anoPpr].start_date = new Date(`${this.anoPprs[anoPpr].start_date}T00:00`)
            if(this.anoPprs[anoPpr].end_date) this.anoPprs[anoPpr].end_date = new Date(`${this.anoPprs[anoPpr].end_date}T00:00`)
            if(this.anoPprs[anoPpr].update_end_date) this.anoPprs[anoPpr].update_end_date = new Date(`${this.anoPprs[anoPpr].update_end_date}T00:00`)
          }

          this.getSuggestion();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getSuggestion() {
      let start_date = this.anoPprs[
        this.anoPprs.length - 1
      ].start_date.split("/");
      start_date[2] = parseInt(start_date[2]) + 1;
      let end_date = this.anoPprs[this.anoPprs.length - 1].end_date.split(
        "/"
      );
      end_date[2] = parseInt(end_date[2]) + 1;
      this.suggestion.descricao = "SAFRA " + start_date[2] + "/" + end_date[2];
      this.suggestion.start_date = start_date.join("/");
      this.suggestion.end_date = end_date.join("/");
    },
    async save() {
      this.savingPeriod = true;
      let params = this.suggestion
      if((this.suggestion.descricao != "" && this.suggestion.start_date != null) && (this.suggestion.end_date != null && this.suggestion.update_end_date != null)){
        const response = await this.$http.secured.post("/api/v1/admin/participation_pprs", params)
        try {
          this.savingPeriod = false;
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.anoPprs.push(response.data);
          this.anoPpr = {};
          this.limpCampos();
        }
        catch(error) {this.setError(error, "Não foi possível salvar o PPR")};
        this.modals.modal0 = false;
      }
    },
    limpCampos(){
      this.suggestion.descricao = "";
      this.suggestion.start_date = dataAtual;
      this.suggestion.end_date = dataAtual;
      this.suggestion.update_end_date = dataAtual;
    },
    remove(anoPpr) {
      console.log(anoPpr)
      if (
        confirm("Deseja excluir o Ano do PPR " + `${anoPpr.descricao}` + "?")
      ) {
        this.$http.secured
          .delete(`/api/v1/admin/participation_pprs/${anoPpr.id}`)
          .then((response) => {
            this.$toasted.global.defaultSuccess();
            this.setData();
            this.anoPprs.splice(this.anoPprs.indexOf(this.anoPpr), 1);
          })
          .catch((error) => this.setError(error, "Cannot delete Ano Safra"));
      }
    },
    formatDate(dateString){
      let dateParts = dateString.split('/');
      let finalString = '' + dateParts[1] + '-' + dateParts[0]
      if (dateParts.length > 2) finalString += '-' + dateParts[2]

      return finalString
    },
    rollbackDate(dateString){
      let dateParts = dateString.split('-');
      let finalString = '' + dateParts[1] + '/' + dateParts[0]
      if (dateParts.length > 2) finalString += '/' + dateParts[2]

      return finalString
    },
    rollbackFilter(filter){
      for (var key in filter) {
        if (
          filter.hasOwnProperty(key) &&
          filter[key] != "" &&
          filter[key].match(/\d+(?:\-\d+)+/)
        ){
          filter[key] = this.rollbackDate(filter[key])
        }

        return filter;
      }
    },
    register() {
      this.suggestion = {}
      this.products = {}
      this.modals.modal0 = true;
    },
    disabledDate(time) {
      return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
    },
  },
  computed: {
    anosafra: {
      get: function() {
        const anosafra_id = this.anoPpr.anosafra_id
        const anosafra = this.anosafras.find(anosafra => anosafra.id == anosafra_id)
        return anosafra
      },
      set: function(anosafra) {
        this.anoPpr = Object.assign({}, this.anoPpr, {
          anosafra_id: anosafra.id
        })
      },
    },
    suggestionDateRange: {
      get: function() {
        console.log('suggestionDateRange.get', this.suggestion.start_date, this.suggestion.end_date)
        return [this.suggestion.start_date, this.suggestion.end_date];
      },
      set: function(range) {
        console.log('suggestionDateRange.set', this.suggestion.start_date, this.suggestion.end_date)
        this.suggestion = Object.assign({}, this.suggestion, {
          start_date: range[0],
          end_date:   range[1],
        })
      },
    },
    anoPprDateRange: {
      get: function() {
        console.log('anoPprDateRange.get', this.anoPpr.start_date, this.anoPpr.end_date)
        return [this.anoPpr.start_date, this.anoPpr.end_date];
      },
      set: function(range) {
        console.log('anoPprDateRange.set', range[0], range[1])
        this.anoPpr = Object.assign({}, this.anoPpr, {
          start_date: range[0],
          end_date:   range[1],
        })
      },
    },
    emptyFilter: function () {
      for (var key in this.filter) {
        if (this.filter.hasOwnProperty(key) && this.filter[key] != "")
          return false;
      }
      return true;
    },
    refactoredFilter: function(){
      let filter = this.filter;

      for (var key in filter) {
        if (
          filter.hasOwnProperty(key) &&
          filter[key] != "" &&
          filter[key].match(/\d+(?:\/\d+)+/)
        ){
          filter[key] = this.formatDate(filter[key])
        }

        return filter;
      }
    },
  },
};
</script>
<style scoped>
.margin {
  margin-bottom: 25px;
}

.page-item.active .page-link{
  color: #fff;
  background-color: #11cdef !important;
  border-color: #11cdef !important;

}

</style>
